module.exports = __webpack_public_path__ + "img/shao.0bc8e7b7.png";